import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IEmailFormActionTypes } from "../../action-types/email/IEmailFormActionTypes";
import { IEmailFormReducer } from "../../page-state-model/email/IEmailFormReducer";
const iniState: IEmailFormReducer = {
    id: 0,
    currentStepId: 1,
    emailUser: [],
    statusEmail: ePageBaseStatus.is_not_initialization,
    statusEmailUser: ePageBaseStatus.is_not_initialization
}
export const emailFormReducer = (state: IEmailFormReducer = iniState, action: IEmailFormActionTypes): IEmailFormReducer => {
    switch (action.type) {
        case "EMAIL_FORM_CHANGE_ID":
            return {
                ...state,
                id: action.payload
            }
        case "EMAIL_FORM_CHANGE_STEP_ID":
            return {
                ...state,
                currentStepId: action.payload
            }
        case "EMAIL_FORM_LOAD_EMAIL_START":
            return {
                ...state,
                statusEmail: ePageBaseStatus.is_loading
            }
        case "EMAIL_FORM_LOAD_EMAIL_SUCCESS":
            return {
                ...state,
                statusEmail: ePageBaseStatus.is_completed,
                email: action.payload
            }
        case "EMAIL_FORM_LOAD_EMAIL_ERROR":
            return {
                ...state,
                statusEmail: ePageBaseStatus.is_completed,
                email: undefined

            }
        case "EMAIL_FORM_SAVE_EMAIL_START":
            return {
                ...state,
                statusEmail: ePageBaseStatus.is_saving
            }
        case "EMAIL_FORM_SAVE_EMAIL_SUCCESS":
            return {
                ...state,
                statusEmail: ePageBaseStatus.is_need_reload,
                id: action.payload,
                currentStepId: 2
            }
        case "EMAIL_FORM_SAVE_EMAIL_ERROR":
            return {
                ...state,
                statusEmail: ePageBaseStatus.is_completed
            }
        case "EMAIL_FORM_LOAD_EMAIL_USER_START":
            return {
                ...state,
                statusEmailUser: ePageBaseStatus.is_loading
            }
        case "EMAIL_FORM_LOAD_EMAIL_USER_SUCCESS":
            return {
                ...state,
                statusEmailUser: ePageBaseStatus.is_completed,
                emailUser: action.payload
            }
        case "EMAIL_FORM_LOAD_EMAIL_USER_ERROR":
            return {
                ...state,
                statusEmailUser: ePageBaseStatus.is_completed,
            }
        case "EMAIL_FORM_SAVE_EMAIL_USER_START":
            return {
                ...state,
                statusEmailUser: ePageBaseStatus.is_saving
            }
        case "EMAIL_FORM_SAVE_EMAIL_USER_SUCCESS":
            return {
                ...state,
                statusEmailUser: ePageBaseStatus.is_need_reload,
                // emailUser: action.payload
            }
        case "EMAIL_FORM_SAVE_EMAIL_USER_ERROR":
            return {
                ...state,
                statusEmailUser: ePageBaseStatus.is_completed,
            }
        case "EMAIL_FORM_SEND_START":
            return {
                ...state,
              currentStepId:4
            }

        default:
            return state;
    }
}